<ct-lib-modal
  #modal
  [small]="true"
  [hideFooter]="true"
  [label]="titleKey() | transloco"
  (onClose)="onDismissed()"
>
  <p class="lead text-muted">
    {{ leadKey() | transloco }}
  </p>
  <div class="choices">
    <button
      type="button"
      class="choice"
      [disabled]="!profileAvailable()"
      (click)="chooseProfile()"
    >
      <b>{{ profileLabelKey() | transloco }}</b>
      <span class="hint text-muted">{{ profileHintKey() | transloco }}</span>
    </button>
    <button
      type="button"
      class="choice"
      [disabled]="!manualAvailable()"
      (click)="chooseManualOption()"
    >
      <b>{{ manualLabelKey() | transloco }}</b>
      <span class="hint text-muted">{{ manualHintKey() | transloco }}</span>
    </button>
  </div>
</ct-lib-modal>
